"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.payment.confirmed': 'Pago Confirmado',
    'route.payment.list': 'Pagos',
    'route.payment.preview': 'Detalles del Pago',
};
